import {Checkbox} from '@/components/commons/checkbox/ChekBox'
import {Badge} from '@/components/ui/badge/Badge'
import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledUserWorkAreasMultiSelectOption = styled(Flexbox)(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[950]};
    `
)

export const StyledUserWorkAreasMultiSelectCheckboxWrapper = styled(Button)(
    ({theme: {palette, spacing}}) => css`
        width: 100%;
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        border-radius: 6px;
        &:hover {
            background-color: ${palette.neutral[100]};
        }
    `
)

export const StyledUserWorkAreasMultiSelectCheckbox = styled(Checkbox)`
    background-color: transparent;
`

export const StyledWorkAreasChipsContainer = styled(Flexbox)`
    flex-wrap: wrap;
`

export const StyledWorkAreasChip = styled(Badge)(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[600]};
        font-weight: 400;
        display: flex;
        align-items: center;
    `
)

export const StyledWorkAreaProvinceAcronym = styled.span(
    ({theme: {palette}}) => css`
        color: ${palette.neutral[500]};
    `
)
